export function getWidgetPlacement(isFullWidth, isInvokedFromHeader) {
  if (isFullWidth) {
    return 'fullPage';
  }
  return isInvokedFromHeader ? 'header' : 'anchor';
}
//# sourceMappingURL=widgetPlacement.js.map